import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ClassSchedule } from 'src/app/core/models/api/class-schedule.model';
import { Classification } from 'src/app/core/models/api/classification.model';
import { Course }         from 'src/app/core/models/api/course.model';
import { Edition }        from 'src/app/core/models/api/edition.model';

import { CampusService }          from 'src/app/core/services/api/campus.service';
import { CourseService }          from 'src/app/core/services/api/course.service';
import { ClassService }           from 'src/app/core/services/api/class.service';
import { EditionResourceService } from 'src/app/core/services/api/edition-resource.service';


@Component({
  selector: 'app-schedules-prices',
  templateUrl: './schedules-prices.component.html',
  styleUrls: ['./schedules-prices.component.scss']
})
export class SchedulesPricesComponent implements OnInit, OnDestroy {

    private editionId : number;
    public  edition   : Edition;
    public  courses   : Course[];
    public  classes   : ClassSchedule[];
    public  webResourceId: string = "schedule-prices-page";

    public campusName    : string;
    public maxDiscount   : number;
    public showFreePlaces: boolean;
    public showOccupation: boolean;

    private courseSubscription  : Subscription;
    private classSubscription   : Subscription;
    private editionSubscription : Subscription;

    constructor(
        private activatedRoute: ActivatedRoute, 
        private campusService: CampusService,
        private courseService: CourseService, 
        private classService: ClassService, 
        private editionService: EditionResourceService,
        private editionResourceService: EditionResourceService) { }
    
    ngOnInit() {

        this.getEditionFromRoute();
        this.subscribeToEditionService();
        this.subscribeToCourseService();

    }

    ngOnDestroy() {
        
        if (this.courseSubscription && !this.courseSubscription.closed) { this.courseSubscription.unsubscribe(); }
        if (this.classSubscription && !this.classSubscription.closed) { this.classSubscription.unsubscribe(); }   
        if (this.editionSubscription && !this.editionSubscription.closed) { this.editionSubscription.unsubscribe(); }
    
    }
        
    private getEditionFromRoute() {

        this.activatedRoute.paramMap.subscribe(params => {
            
            this.editionId = +params.get("editionId");
            this.campusName = this.campusService.campusActive.name;
            this.editionService.getEditionById(this.editionId).subscribe();
            this.classService.getClassesScheduleByEditionId(this.editionId).subscribe();

        });

    }

    private subscribeToEditionService() {

        this.editionSubscription = this.editionService.editionActiveData$.subscribe({
            next: (data) => { 
                this.edition = data;
                this.getEditionResources();
            }
        });

    }

    private subscribeToCourseService() {

        this.classSubscription = this.classService.classesScheduleActiveData$.subscribe({
            next: (data) => { 
                this.classes = data;
            }
        });

    }

    public getDistinctClassifications() : Classification[] {

        var arrayClassifications = [...new Set(this.classes.map(cl => cl.classification))]
        var allClassifications   = [].concat(...arrayClassifications);
        var classifications = allClassifications.reduce((classification, x) => classification.concat(classification.find((y: Classification) => y.classificationId === x.classificationId) ? [] : [x]) , []);
        
        return classifications;

    }

    public getClassesByClassification(classification: Classification) : ClassSchedule[] {
        
        var arrayClasses = [...new Set(this.classes.filter(cl => !cl.cancelled && !cl.closed))]
        var allClasses   = [].concat(...arrayClasses);

        return allClasses.filter((cl: ClassSchedule) => cl.classificationId === classification.classificationId);

    }

    private getEditionResources() {

        this.maxDiscount    =   +this.editionResourceService.findResource(this.edition.resources, 'max-discount');
        this.showFreePlaces = !!+this.editionResourceService.findResource(this.edition.resources, 'show-free-places');
        this.showOccupation = !!+this.editionResourceService.findResource(this.edition.resources, 'show-occupation');
    }
    
}
